import { render } from "./edit-source-modal.vue?vue&type=template&id=50ab9ce6&scoped=true"
import script from "./edit-source-modal.vue?vue&type=script&lang=js"
export * from "./edit-source-modal.vue?vue&type=script&lang=js"

import "./edit-source-modal.vue?vue&type=style&index=0&id=50ab9ce6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ab9ce6"]])

export default __exports__